import React,{useEffect,useState}from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import CreateViewEditDropList from "./create-view-edit-droplist";
import InnerLayout from "../../../components/layouts/inner-layout";
import { warehouseGetIdAction } from "../../../redux/actions/inventory-action";
import { CreateDropList } from "../../../redux/actions/purchase-action";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import errorToast from "../../../components/helper-components/error-toast";
import { useNavigate } from "react-router-dom";

const DROP_LIST_SOURCES = {
  goods: { idKey: "gort_id", addressPrefix: "gort" },
  invoice: { idKey: "poit_id", addressPrefix: "poit" },
};

const AddDropList = () => {
  const { itemId, type } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const itemIdArray = JSON.parse(decodeURIComponent(itemId));
  const source = DROP_LIST_SOURCES[type] ?? DROP_LIST_SOURCES.goods;
  const [loading,setLoading]=useState(true);
  const [orderDetail,setOrderDetail]=useState({});
  const [warehouseId, setWarehouseId] = useState(null);
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};

  useEffect(() => {
    dispatch(warehouseGetIdAction({},onWarehouseSuccess,onWarehouseError))
  }, []);
  const onWarehouseSuccess = (res) => {
    const { idKey } = source;
    const docMap = itemIdArray.reduce((acc, item) => {
      const docId = item[idKey];
      const doc = acc[docId] ?? { [idKey]: docId, item_ids: [] };
      return {
        ...acc,
        [docId]: item.item_id
          ? { ...doc, item_ids: [...doc.item_ids, item.item_id] }
          : doc,
      };
    }, {});
    const data={
        warehouse_id: res?.data?.pos_id,
        [idKey]: Object.values(docMap),
        dropper_id: null
    }
    setWarehouseId(res?.data?.pos_id ?? null);
    dispatch(CreateDropList(data,onCreateDropListSuccess,onCreateDropListError));
  };
  const navigate = useNavigate();
  const onWarehouseError = (err) => {
    errorToast(err?.data?.message);
  };
  const onCreateDropListSuccess = (data) => {
    setOrderDetail(data?.data)
    setLoading(false);
  }
  const onCreateDropListError = (err) => {
    setLoading(false);
    navigate(-1);
    errorToast(err?.data?.message);
  };
  return (
    <>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <InnerLayout backBtn={true} title="Add Drop List">
            <CreateViewEditDropList
                vendorDetails={[vendorDetails]}
                itemData={orderDetail?.itemData}
                payto={ vendorDetails?.[`${source.addressPrefix}_pay_to_address`]}
                shipto={vendorDetails?.[`${source.addressPrefix}_ship_to_address`]}
                dropListId={orderDetail?.drop_list_id}
                warehouseId={warehouseId}
                clickedplus={true}
                pageType='droplist'
                page='add'
                disabled={false}
                created_date={vendorDetails?.created_date}
            />
          </InnerLayout>
        )}
    </>
  );
};
export default AddDropList;
